import { useState } from 'react';
import LinkedPropertiesModal from '../components/CrmObjectPreviewModal/LinkedPropertiesModal';
import { jsx as _jsx } from "react/jsx-runtime";
const useLinkedPropertiesModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  return [openModal, /*#__PURE__*/_jsx(LinkedPropertiesModal, {
    isOpen: isOpen,
    closeModal: closeModal
  }, "LinkedPropertiesModal")];
};
export default useLinkedPropertiesModal;